

export const DURATION_DISPLAY = [
    {label: 'Work Schedule', value: 1},
    {label: 'Calendar Days', value: 2},
    {label: 'Deduction Quantity', value: 3},
]


export const ALLOWANCE_ENTITLEMENT = [
    {label: '1 year', value: 1},
    {label: '2 year', value: 2},
    {label: '3 year', value: 3},
    {label: '4 year', value: 4},
    {label: '5 year', value: 5},
    {label: 'Once for a service period', value: 6},
]

